module.exports = __webpack_public_path__ + "static/cii-962bbcfe947049d54f7cb6cff0214620.svg";